export const AssociateDetailReducer = (state, action) => {
    switch (action.type) {
        case "SET_ASSOCIATE":
            return {...state, associate: action.data}
        case "RESET_ASSOCIATE_SELECTION":
            return {...state, associate: []}
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/associate/reducer/AssociateDetailReducer.js